import React, { useRef } from "react";
import UserWidget from "@/components/elements/UserWidget";
import { User } from "@/utils/user";
import tw from "twin.macro";
import VerifyBadge from "@/components/elements/VerifyBadge";

type Props = {
  onChange: (checked: boolean) => void;
  checked?: boolean;
  user: User;
};

const ShareUser = ({ onChange, user, checked = false }: Props) => {
  const checkboxRef = useRef<HTMLInputElement>(null);

  return (
    <>
      <button
        className="grid grid-cols-[1fr,auto] gap-4 items-center w-full"
        onClick={() => {
          onChange(!checkboxRef.current?.checked);
        }}
      >
        <div className="pointer-events-none inline-flex items-center gap-1">
          <div className="grid grid-cols-[1fr,auto] items-center gap-1">
            <div className="overflow-x-hidden">
              <UserWidget
                user={user}
                follow={false}
                online={false}
                size={45}
                sideName={true}
                showName={true}
                nameStyle={tw`font-normal truncate`}
              />
            </div>
            <VerifyBadge type={user.type} />
          </div>
        </div>
        <input
          ref={checkboxRef}
          type="checkbox"
          checked={checked}
          className="h-4 w-4 rounded-full border-gray-300 text-blue-500 focus:ring-offset-0 pointer-events-none"
        />
      </button>
    </>
  );
};

export default ShareUser;
